import { render, staticRenderFns } from "./AreaNav.vue?vue&type=template&id=05d1aeaa"
import script from "./AreaNav.vue?vue&type=script&lang=js"
export * from "./AreaNav.vue?vue&type=script&lang=js"
import style0 from "./AreaNav.vue?vue&type=style&index=0&id=05d1aeaa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports